<template>
  <div id="basic-info" class="card mt-4">
    <div class="card-header">
      <h5>{{ $t('settings.Reference') }}</h5>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-4">
            <div class="input-group input-group-static null">
                <label>{{ $t('settings.Code') }}</label>
                <input v-model="state.code" type="text"
                    class="form-control form-control-default"
                    :placeholder="$t('settings.Code')">
            </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('settings.Name') }} *</label>
            <input v-model="state.name" type="text" class="form-control form-control-default"
              :placeholder="$t('settings.Name')">
            <span v-if="v$.name.$error" class="text-sm text-danger">
              {{ v$.name.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('settings.Reference_type') }} *</label>
            <select id="referenceTypeId" v-model="state.referenceTypeId" class="form-control form-control-default">
              <option value="">{{ $t('settings.Select_reference_type') }}
              </option>
              <option v-for="referencetype in state.referencetypes" :key="referencetype.id" :value="referencetype.id">
                {{ referencetype.name }}
              </option>
            </select>
            <span v-if="v$.referenceTypeId.$error" class="text-sm text-danger">
              {{ v$.referenceTypeId.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <div class="input-group input-group-static null">
            <label>{{ $t('settings.Description') }}</label>
            <textarea class="form-control form-control-default" :rows="4" v-model="state.description"
              :placeholder="$t('settings.Description')"></textarea>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 mt-6">
        <input type="hidden" v-model="state.id" class="form-control">
        <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel')
          }}</router-link>
        <button v-on:click="updateReference" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import * as Choices from "choices.js";
import axios from 'axios'
import useValidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n';

export default {
  name: "ReferenceDetail",
  setup() {
    const { t } = useI18n()

    const state = reactive({
      reference: [],
      referencetypes: [],
      id: '',
      code: '',
      name: '',
      referenceTypeId: '',
      description: ''
    })

    const rules = computed(() => {
      return {
        name: { required: helpers.withMessage(t('common.Required'), required) },
        referenceTypeId: { 
            required: helpers.withMessage(t('common.Required'), required),
            isSelected: helpers.withMessage(t('common.Select_a_reference_type'), value => value !== '')
        }
      }
    })

    const v$ = useValidate(rules, state)

    return {
      state,
      v$,
      choicesInstance: null // Store Choices instance
    }
  },
  components: {
  },
  data() {
    return {
      gets: [],
      error: '',
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.fetchReferenceData(this.$route.params.id);
    this.initializeChoices();
  },
  methods: {
    async fetchAllReferenceTypeData() {
      try {
        const response = await axios.get("ReferenceType/getall");
        const result = response.data;

        if (result.success && Array.isArray(result.data)) {
          this.state.referencetypes = result.data;
        } else {
          this.$showError('errors.Error_fetching_reference_type');          
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      }
    },

    async fetchReferenceData(referenceId) {
      try {
        
        this.$store.commit('setShowLoading', true);

        const response = await axios.get(`Reference/${referenceId}`);
        this.gets = response.data;

        if (this.gets.success) {
          this.state.reference = this.gets.data;
          this.state.id = this.state.reference.id;
          this.state.code = this.state.reference.code;
          this.state.name = this.state.reference.name;
          this.state.referenceTypeId = this.state.reference.referenceTypeId;
          this.state.description = this.state.reference.description;

          await this.fetchAllReferenceTypeData();
        } else {
          this.$showError('errors.Contact_system_admin');
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {      
        this.$store.commit('setShowLoading', false);
      }
    },

    initializeChoices() {
      const element = document.getElementById("referenceTypeId");
      if (this.choicesInstance) {
        this.choicesInstance.destroy(); // Clean up previous instance
      }

      this.choicesInstance = new Choices(element, {
        searchEnabled: true,
        shouldSort: false,
        placeholder: true,
        //placeholderValue: '-- Select register --', 
      });

      // Set the dropdown options
      if (Array.isArray(this.state.referencetypes) && this.state.referencetypes.length > 0) {
        // Check if the referenceTypeId exists among the referencetypes
        if (this.state.referenceTypeId) {
          const optionExists = this.state.referencetypes.some(x => x.id === this.state.referenceTypeId);
          if (optionExists) {
            this.choicesInstance.setChoiceByValue([this.state.referenceTypeId]); // Set the selected value
          } else {
            this.choicesInstance.setChoiceByValue(''); // Clear if no match found
          }
        }
      }

      // Listen for changes and update state
      element.addEventListener('change', (event) => {
        this.state.referenceTypeId = event.target.value; // Update the state
        this.v$.$validate(); // Trigger validation
      });
    },

    async updateReference() {
      try {
        this.$store.commit('setShowLoading', true);

        this.v$.$validate();
        console.log(this.v$.$error);

        if (!this.v$.$error) {
          const response = await axios.put('Reference/update', {
            "id": this.state.id,
            "code": this.state.code,
            "name": this.state.name,
            "referenceTypeId": this.state.referenceTypeId,
            "description": this.state.description,
          });
          this.gets = response.data;

          if (this.gets.success) {
            this.$showSuccess('errors.Success_reference_updated_successfully');
            this.$router.push('/settings');
          } else {
            this.$showError('errors.Contact_system_admin');            
          }
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      }
      this.$store.commit('setShowLoading', false);
    },
  }
};
</script>
<style>
.choices {
  margin-bottom: 0px !important;
}
</style>